import React, { Component } from 'react';
import voca from 'voca';
import CustomInputWithIcon from '../../../common/ui/CustomInputWithIcon';

export class ExternalApiError extends Component {
  getInputValue = (value) => {
    return typeof value === 'string' ? value : '';
  };

  updateErrorRow = (field, value) => {
    const nextValue = field === 'path' ? voca.trim(value) : value;

    this.props.createNewErrorRow({
      ...this.props.error,
      [field]: nextValue,
    });
  };

  onPathChange = (e) => {
    this.updateErrorRow('path', e.target.value);
  };

  onValueChange = (e) => {
    this.updateErrorRow('value', e.target.value);
  };

  onMessageChange = (e) => {
    this.updateErrorRow('message', e.target.value);
  };

  render() {
    const { error } = this.props;

    return (
      <div className="row">
        <div className="col-md-1">{error.id}.</div>
        <div className="col-md-11">
          <div className="row">
            <div className="col-md-4">
              <CustomInputWithIcon icon="text" title="JSON path of error field">
                <input
                  name="errorPath"
                  onChange={this.onPathChange}
                  value={this.getInputValue(error.path)}
                  className="form-control form-control-sm"
                  placeholder="JSON path of error field"
                  title="JSON path of error field"
                  required={true}
                />
              </CustomInputWithIcon>
            </div>
            <label className="col-md-2 text-muted mt-2 w-50">is equals to</label>
            <div className="col-md-4 ">
              <CustomInputWithIcon icon="text" title="Error field value">
                <input
                  name="errorValue"
                  onChange={this.onValueChange}
                  value={this.getInputValue(error.value)}
                  className="form-control form-control-sm"
                  placeholder="Error field value"
                  title="Error field value"
                />
              </CustomInputWithIcon>
            </div>
            <label className="col-md-2 text-muted mt-2">then it's an error</label>
          </div>
          <div className="row">
            <div className="col-md-12 col-lg-12 col-sm-12">
              <CustomInputWithIcon icon="text" title="JSON path of error message field">
                <input
                  name="errorMsg"
                  onChange={this.onMessageChange}
                  value={this.getInputValue(error.message)}
                  className="form-control form-control-sm mr-2"
                  placeholder="JSON path of error message field"
                  title="JSON path of error message field"
                />
              </CustomInputWithIcon>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ExternalApiError;
